import { BoxGeometry, CylinderGeometry, Group, Mesh, MeshStandardMaterial, SphereGeometry } from 'three';
import { Rng } from '../../core/rng';
import { flatMaterial } from '../../render/materials/cache';
import { canvasTexture, repeating } from '../../render/materials/canvasTexture';

const UNIT = new BoxGeometry(1, 1, 1);

function block(color: string, w: number, h: number, d: number, x: number, y: number, z: number): Mesh {
  const mesh = new Mesh(UNIT, flatMaterial(color));
  mesh.scale.set(w, h, d);
  mesh.position.set(x, y, z);
  mesh.castShadow = true;
  return mesh;
}

function wheel(radius: number, x: number, z: number): Mesh {
  const mesh = new Mesh(new CylinderGeometry(radius, radius, 0.14, 14), flatMaterial('#151515'));
  mesh.rotation.z = Math.PI / 2;
  mesh.position.set(x, radius, z);
  return mesh;
}

/** Aboboyaa: motor-tricycle with an open cargo bed, usually overloaded. */
export function buildAboboyaa(seed: number): Group {
  const rng = new Rng(seed);
  const group = new Group();
  const bed = rng.pick(['#264653', '#1d3557', '#6c757d']);
  group.add(block(bed, 1.5, 0.12, 1.7, 0, 0.62, 0.55), block(bed, 1.5, 0.4, 0.06, 0, 0.85, 1.4));
  group.add(block(bed, 0.06, 0.4, 1.7, -0.75, 0.85, 0.55), block(bed, 0.06, 0.4, 1.7, 0.75, 0.85, 0.55));
  const load = ['#8d6e63', '#d4a373', '#606c38', '#bc6c25'];
  for (let i = 0; i < 4; i += 1) {
    group.add(block(rng.pick(load), rng.range(0.4, 0.6), rng.range(0.35, 0.6), rng.range(0.4, 0.6), rng.range(-0.4, 0.4), 0.95, 0.2 + i * 0.35));
  }
  group.add(block('#1b1b1b', 0.3, 0.45, 1.0, 0, 0.6, -0.8), block('#b5121b', 0.35, 0.3, 0.5, 0, 0.95, -1.0));
  group.add(block('#2b2d42', 0.4, 0.55, 0.3, 0, 1.4, -0.75));
  const head = new Mesh(new SphereGeometry(0.15, 10, 8), flatMaterial('#4a2c1d'));
  head.position.set(0, 1.85, -0.78);
  group.add(head, wheel(0.28, 0, -1.3), wheel(0.3, -0.75, 0.8), wheel(0.3, 0.75, 0.8));
  return group;
}

let stripeMaterial: MeshStandardMaterial | null = null;

/** Red-and-white road-works barrier you can hop over. */
export function buildBarrier(width: number, height: number): Group {
  stripeMaterial ??= new MeshStandardMaterial({
    map: repeating(
      canvasTexture(64, 16, (ctx) => {
        ctx.fillStyle = '#f7f7f7';
        ctx.fillRect(0, 0, 64, 16);
        ctx.fillStyle = '#d00000';
        ctx.fillRect(0, 0, 32, 16);
      }),
      5,
      1,
    ),
  });
  const group = new Group();
  const rail = new Mesh(UNIT, stripeMaterial);
  rail.scale.set(width, 0.3, 0.12);
  rail.position.y = height - 0.2;
  rail.castShadow = true;
  group.add(rail, block('#f7f7f7', 0.1, height, 0.5, -width / 2 + 0.2, height / 2, 0), block('#f7f7f7', 0.1, height, 0.5, width / 2 - 0.2, height / 2, 0));
  return group;
}
